import * as React from "react";
import {TournamentConstraints} from "../../../../generated/protocol";
import {FormGroup} from "../../form/FormGroup";
import {FormInput} from "../../form/FormInput";
import {FormComponentProps} from "../../form/Form";
import {FormTransferContainer} from "../../form/FormTransferContainer";
import {Validators} from "../../form/Validators";


interface RebuyConfigurationProps extends FormComponentProps {
    constraints?: TournamentConstraints;
}

export class RebuyConfigPanel extends React.Component<RebuyConfigurationProps, {}> {
    render() {
        return (
            <FormTransferContainer {...this.props} model="configuration.rebuyConfiguration">
                <FormGroup className="form-group">
                    <label className="col-sm-2 control-label">Rebuy And Add-on Timeout</label>
                    <div className="col-sm-10">
                        <FormInput model="rebuyAndAddonTimeout" type="integer" className="form-control"
                                   validators={[Validators.required(), Validators.integer()]}/>
                        <span className="help-block m-b-none">
                            The time in milliseconds a player has to respond to a rebuy or add-on request
                      </span>
                    </div>
                </FormGroup>
                <div className="hr-line-dashed"></div>
                <FormGroup className="form-group">
                    <label className="col-sm-2 control-label">Number of Rebuys Allowed</label>
                    <div className="col-sm-10">
                        <FormInput model="numberOfRebuysAllowed" type="integer" className="form-control"
                                   validators={[Validators.required(), Validators.integer()]}/>
                        <span className="help-block m-b-none">
                            The number of rebuy that are allowed for a player during the rebuy period. For unlimited number of rebuys set it to -1
                      </span>
                    </div>
                </FormGroup>
                <div className="hr-line-dashed"></div>
                <FormGroup className="form-group">
                    <label className="col-sm-2 control-label">Rebuy Blinds Levels</label>
                    <div className="col-sm-10">
                        <FormInput model="numberOfLevelsWithRebuys" type="integer" className="form-control"
                                   validators={[Validators.required(), Validators.integer()]}/>
                        <span className="help-block m-b-none">
                            The number of blinds levels during which rebuys are allowed.
                            NOTE: if the tournament has add-ons enabled, make sure that there is a break after the level where the rebuys stop.
                            For example, if you want rebuys during the first hour and then add-ons, if each level is 10 minutes,
                            you should set this to "6" and make sure that the 7th level is a break.
                      </span>
                    </div>
                </FormGroup>
                <div className="hr-line-dashed"></div>
                <FormGroup className="form-group">
                    <label className="col-sm-2 control-label">Rebuy Cost</label>
                    <div className="col-sm-10">
                        <FormInput model="rebuyCost" type="float" className="form-control"
                                   validators={[Validators.required()]}/>
                    </div>
                </FormGroup>
                <div className="hr-line-dashed"></div>
                <FormGroup className="form-group">
                    <label className="col-sm-2 control-label">Chips for Rebuy</label>
                    <div className="col-sm-10">
                        <FormInput model="chipsForRebuy" type="float" className="form-control"
                                   validators={[Validators.required()]}/>
                    </div>
                </FormGroup>
                <div className="hr-line-dashed"></div>
                <FormGroup className="form-group">
                    <label className="col-sm-2 control-label">Max Stack for Rebuy</label>
                    <div className="col-sm-10">
                        <FormInput model="maxStackForRebuy" type="float" className="form-control"
                                   validators={[Validators.required()]}/>
                    </div>
                </FormGroup>

                <div className="hr-line-dashed"></div>
                <FormGroup className="form-group">
                    <label className="col-sm-2 control-label">Addons enabled</label>
                    <div className="col-sm-10">
                        <FormInput model="addOnsEnabled" type="checkbox"/>
                    </div>
                </FormGroup>
                <div className="hr-line-dashed"></div>
                <FormGroup className="form-group">
                    <label className="col-sm-2 control-label">Addon Cost</label>
                    <div className="col-sm-10">
                        <FormInput model="addOnCost" type="text" className="form-control"/>
                    </div>
                </FormGroup>
                <div className="hr-line-dashed"></div>
                <FormGroup className="form-group">
                    <label className="col-sm-2 control-label">Chips for Add-on</label>
                    <div className="col-sm-10">
                        <FormInput model="chipsForAddOn" type="float" className="form-control"
                                   validators={[Validators.required()]}/>
                    </div>
                </FormGroup>
                <div className="hr-line-dashed"></div>
            </FormTransferContainer>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/ui/poker/tournament/RebuyConfigPanel.tsx